import { FC } from 'react';
import SearchFormItem from './subpage/searchFormItem';
import SuperUpload from '../SuperUpload';
import { UploadImageProps } from '../SuperUpload/uploadImage';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormUploadImageProps extends BaseSearchFormItemProps {
  uploadImageProps?: UploadImageProps;
}
/** 上传图片 */
export const SearchFormUploadImage: FC<SearchFormUploadImageProps> = props => {
  const {
    style,
    name,
    isDetail,
    form,
    testId,
    uploadImageProps,
    ...resProps
  } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SearchFormItem
      name={name}
      form={form}
      {...resProps}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      className={uploadImageProps?.size === 'auto' ? 'upload-image-full' : ''}
      test-id={`${testId}-${name}`}
    >
      <SuperUpload disabled={isDetail} style={style} {...uploadImageProps} />
    </SearchFormItem>
  );
};

SearchFormUploadImage.displayName = SearchFormItemEnum.SearchFormUploadImage;

export default SearchFormUploadImage;
